<form-control-container #container
                        [control]="controlInstance"
                        [class.readonly]="isReadonlyValue">

  <div label-extension>
    <ng-content select="[label-extension]"></ng-content>
  </div>

  <ng-container *ngIf="!isReadonlyValue">
    <div class="input-group">

      <div class="input-container">
        <input #fileInput
               type="file"
               (change)="onFilesChange($event)">
        <img src="/assets/images/icons/files/file-icon.svg"
             class="file-wrapper-icon"/>
        <div class="file-wrapper-text">
          <span>{{ 'Controls.FileInput.DragFilesOr' | translate }}</span>&nbsp;<span class="red">{{ 'Controls.FileInput.BrowseToUpload' | translate }}</span>
        </div>
      </div>

      <div *ngIf="value"
           class="attachment">
        <img src="/assets/images/icons/files/scrape.svg"/>
        <div class="attachment-name">{{value.name}}</div>
        <img class="attachment-remove"
             src="/assets/images/icons/close_popup_red.svg"
             (click)="clearValue()"/>
      </div>

    </div>
  </ng-container>

</form-control-container>
